// extracted by mini-css-extract-plugin
export default {"root":"home5_root__yEmJ8","accroche2":"home5_accroche2__bNNNG"};